import axios from "axios";
import { getCookie } from "./varConfig";

// export const BASE_URL = "http://3.108.80.130:5001";
export const BASE_URL = "https://www.astrodhyaan.com";
export const API_URL =  BASE_URL +"/api/admin";

// Create an Axios instance 
export const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
  });
  
  // Add a request interceptor to attach the token to every request
  api.interceptors.request.use(
    (config) => {
      const token =  getCookie("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {  
      return Promise.reject(error);
    }
  );